/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmAddressSummaryInfo } from './EvmAddressSummaryInfo';
import type { EvmTokenSummaryInfo } from './EvmTokenSummaryInfo';

export type KiteTokenTransferInfo = {
    STAT: KiteTokenTransferInfo.STAT;
    TRXHA: string;
    AG: string;
    UT: number;
    MTH: string;
    BNO: string;
    ADDRSFROMINFO: EvmAddressSummaryInfo;
    ADDRSTOINFO: EvmAddressSummaryInfo;
    VAL: string;
    LI: string;
    TI: string;
    NFTNAME: string;
    TSI: EvmTokenSummaryInfo;
};

export namespace KiteTokenTransferInfo {

    export enum STAT {
        SUCCESS = 'SUCCESS',
        FAILURE = 'FAILURE',
        PENDING = 'PENDING',
        FAILED = 'FAILED',
        OUT_COMING = 'OUT_COMING',
        IN_COMING = 'IN_COMING',
        ALL = 'ALL',
    }


}

